import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import PrecisionDemolitionRapidHauling from "./sections/PrecisionDemolitionRapidHauling";
import GetYourInstantQuote from "./sections/GetYourInstantQuote";
import OurScrapCarSolutions from "./sections/OurScrapCarSolutions";
import ThreeSimpleStepsToCash from "./sections/ThreeSimpleStepsToCash";
import WhyBcChoosesUs from "./sections/WhyBcChoosesUs";
import WhatOurClientsSay from "./sections/WhatOurClientsSay";
import ContactFooterInformation from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <PrecisionDemolitionRapidHauling />
      <GetYourInstantQuote />
      <OurScrapCarSolutions />
      <ThreeSimpleStepsToCash />
      <WhyBcChoosesUs />
      <WhatOurClientsSay />
      <ContactFooterInformation />
    </div>;
}